import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationUserLookup extends ModelBase {

    public organisationUserId: number = 0;

    public organisationId: number = 0;

    public userId: number = 0;

    public organisationName: string = "";

    public userName: string = "";
}